
import TocList from '@/components/TocList'
export default {
    components:{
        TocList
    },
    data(){
        return{
            headings:[]
        }
    },
    computed: {
  groupedHeadings() {
    let items = [...this.headings]
    for(let i = items.length - 1; i >= 0; i--){
        let currentItem = items[i];
        let parentItem = items.findLast((item,index) => {
            return item.level < currentItem.level && index < i;
        })
        if(parentItem){
            parentItem.subHeadings.unshift(currentItem);
            items.splice(i,1)
        }
    }
    return items;
},
    },
    mounted(){
        this.getAllTags();
    },
    methods:{
        getAllTags(){
            window.document.querySelector('.blog-details').querySelectorAll("h1,h2,h3,h4,h5,h6")
            .forEach(el => {
                let id = this.string_to_slug( el.innerText)
                el.setAttribute("id", id)
                this.headings.push({
                    id: id,
                    level: parseInt(el.tagName.charAt(1), 10),
                    content: el.innerText,
                    subHeadings: [],
                });
            })
        },
        string_to_slug(str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
        // remove accents, swap ñ for n, etc
        var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to = "aaaaaeeeeiiiioooouuuunc------";
        for (var i = 0, l = from.length; i < l; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
          .replace(/\s+/g, '-') // collapse whitespace and replace by -
          .replace(/-+/g, '-'); // collapse dashes
        return str;
      },
    }
}
